import { render } from "./ProductModelDetails.vue?vue&type=template&id=c6882dd0&scoped=true"
import script from "./ProductModelDetails.vue?vue&type=script&lang=js"
export * from "./ProductModelDetails.vue?vue&type=script&lang=js"

import "./ProductModelDetails.vue?vue&type=style&index=0&id=c6882dd0&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6882dd0"]])

export default __exports__